module.exports = __webpack_public_path__ + "@/assets/img/warning-circle.80a10179.svg";